// System status as the Application API serves it (`GET /api/status`): the Application API, the worker, the model
// gateway, each Channel and the last backup, each working, slow or down and since when, and for LAMP's own Owners its
// own tax invoices. Dates are ISO 8601.
import { call, type Fetch } from "../http.js";

export type PartState = "working" | "slow" | "down";
export type StatusChannel = "web_chat" | "telegram" | "whatsapp" | "email";

export interface PartStatus {
  readonly state: PartState;
  readonly since: string;
}

/** Why a payment to LAMP has no tax invoice yet (ADR-0029); each can be mended. */
export type LampInvoiceReason = "own_particulars_missing" | "particulars_missing" | "refused" | "failed" | "waiting";

/** LAMP's own invoices, shown to LAMP's own Owners only: whether LAMP can invoice, and each payment it has not. */
export interface LampInvoicesStatus {
  /** What LAMP's own Tenant lacks before it can invoice; null when nothing. */
  readonly notReady: string | null;
  readonly outstanding: readonly {
    readonly tenantId: string;
    readonly payment: string;
    readonly reason: LampInvoiceReason;
    /** The reason in the API's plain words: a refusal says what refused it. */
    readonly said: string;
  }[];
}

export interface StatusView {
  readonly checkedAt: string;
  readonly parts: { readonly api: PartStatus; readonly worker: PartStatus; readonly models: PartStatus };
  readonly channels: readonly ({ readonly channel: StatusChannel } & PartStatus)[];
  /** Null when this LAMP Cell keeps no backup report. */
  readonly backup: (PartStatus & { readonly lastBackupAt: string | null }) | null;
  /** Only for LAMP's own Tenant's Owners. */
  readonly lampInvoices?: LampInvoicesStatus;
}

export interface StatusApi {
  view(): Promise<StatusView>;
}

export const createStatusApi = (fetcher: Fetch): StatusApi => ({
  view: () => call<StatusView>(fetcher, "/api/status"),
});
